import React from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField) ({
  '& .MuiFilledInput-root': {
    borderRadius: '0px',
    height: '36px',
    
  },
  '& .MuiFilledInput-input': {
    padding: '10px',
    fontSize: '16px',
  },
  width: '100%',
});

const DisabledTextField = ({  width,placeholder,value}) => (
  <StyledTextField
  sx={{maxWidth: width}}
  size= 'small'
  disabled
  variant='filled'
  placeholder={placeholder}
  value={value}
  />
);

export default DisabledTextField;